import React from "react";
import styled from "styled-components";

const TextInputDiv = styled.div`
  .suffix {
    display: table-cell;
    padding: 6px 0;
  }

  &.nowrap {
    .text-input-label{
      white-space: nowrap;
    }
  }
`;

const TextInput = ({
  onChange,
  name,
  label = "Text",
  type = "text",
  disabled = false,
  className = "",
  placeholder = null,
  defaultValue,
  icon = undefined,
  autocomplete = "off",
  labelClassName = '',
  suffix = undefined,
  addon = undefined,
  nowrap = false,
  ...rest
}) => (
  <TextInputDiv className={`input-group ${className} ${nowrap ? 'nowrap' : ''}`}>
    <span className="input-control-addon padding-0">
      {icon !== undefined ? (
        <div className="icon-label">
          <i className="material-icons">{icon}</i>
        </div>
      ) : null}
      {icon !== undefined ? (
        <div className={`text-input-label label-icon ${labelClassName}`}>{label}</div>
      ) : (
        <div className={`text-input-label no-class ${labelClassName}`}>{label}</div>
      )}
    </span>
    <div className="form-line">
      <input
        type={type}
        name={name}
        onKeyUp={onChange}
        disabled={disabled}
        defaultValue={defaultValue}
        placeholder={placeholder}
        className="form-control"
        autoComplete={autocomplete}
        {...rest}
      />
      {suffix !== undefined
        && (<span className="suffix">{suffix}</span>)
        || null
      }
    </div>
      {addon !== undefined
        && (<span className="input-group-addon">{addon}</span>)
        || null
      }
  </TextInputDiv>
);

export default TextInput;
